module.exports = __webpack_public_path__ + "img/public/SiteIcons/twitterLogo.svg?9e3c3aea";